import React, {useState} from 'react';
import {Post} from '../types';
import {Modal} from './Modal';

type FormPostsProps = {
    posts: Post[];
};

export const FormPosts: React.FunctionComponent<FormPostsProps> = ({
                                                                       posts,
                                                                   }): JSX.Element => {

    const [showPostContentModal, setShowPostContentModal] = useState<boolean>(false);
    const [currentPost, setCurrentPost] = useState<Post>();

    return (
        <div>
            <div className="form-sidebar-container">
                <h4 className="form-sidebar-title"><strong>Documentation</strong></h4>
                <ul>
                    {posts.map((post: Post) => (
                        <li key={post.id}>
                            <article id={`post-${post.id}`}>
                                {post.format === 'link' ?
                                    <a href={post.link} className="btn btn-link" target="_blank">{post.title}</a>
                                    :
                                    <button className="btn btn-link"
                                            onClick={() => {
                                                setCurrentPost(post);
                                                setShowPostContentModal(true);
                                            }}
                                    >{post.title}</button>
                                }
                            </article>
                        </li>
                    ))}
                </ul>
            </div>
            {showPostContentModal && currentPost && <Modal size="xl">
                <div className="modal-header">
                    <h5 className="modal-title">{currentPost.title}</h5>
                    <button type="button"
                            className="close"
                            aria-label="Close"
                            tabIndex={-1}
                            onClick={() => {
                                setShowPostContentModal(false);
                            }}
                    >
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body" dangerouslySetInnerHTML={{__html: currentPost?.content}} />
            </Modal>}
        </div>
    );
};